import { render } from "./FitnesView.vue?vue&type=template&id=751153e6&scoped=true"
import script from "./FitnesView.vue?vue&type=script&lang=js"
export * from "./FitnesView.vue?vue&type=script&lang=js"

import "./FitnesView.vue?vue&type=style&index=0&id=751153e6&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/.pnpm/vue-loader@17.4.2_@vue+comp_b828ca3935601f9354f53de73adb2d35/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-751153e6"]])

export default __exports__